import api from '@/apis/di/dvcStateTreasuryAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid CTMT
export const useStateTreasuryComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onStateTreasuryComboboxLoadData = (payload, row, column) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'state_bank_code';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  return {
    onStateTreasuryComboboxLoadData, // trả về thêm để dùng chung chả cả combo ko thuộc grid
  };
};
